var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16.5L15 25v3m8.5-11.5l2-2 2 2 2 2-2 2m-4-4l4 4m0 0L19 29h-3m-1-1v1h1m-1-1l1 1M22 29h7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgEdit;